<template >
  <div class="mainbody">
    <div style="padding: 16px 32px 16px 0">
      <span class="title">校友企业列表</span>
      <el-button
        type="primary"
        size="small"
        style="float: right; letter-spacing: 4px"
        @click="toAdd()"
      >
        <span class="el-icon-plus">新建</span>
      </el-button>
    </div>
    <div class="aLine"></div>
    <div class="tableInfo">
      <el-table
        class="tableInfotext"
        :data="data_list"
        stripe
      >
        <el-table-column
          prop="id"
          label="序列"
          width="auto"
          min-width="8%"
        ></el-table-column>
        <el-table-column
          prop="title"
          label="企业名称"
          width="auto"
          min-width="47%"
          style="
            font-family: 'PingFang SC';
            font-style: normal;
            font-weight: 400;
            font-size: 14px;
            line-height: 22px;
            color: rgba(0, 0, 0, 0.65);
          "
        ></el-table-column>
        <el-table-column label="缩略图" width="auto" min-width="20%">
          <template slot-scope="scope">
            <el-image
              style="width: 65px; height: 75px"
              :src="scope.row.thumb"
              fit="cover"
            >
              <!-- <divfit="cover"
                    slot="error"
                    class="image-slot"
                    style="position: absolute; top: 50%; left: 50%"
                  >
                    <i class="el-icon-picture-outline"></i>
                  </div> -->
            </el-image>
          </template>
        </el-table-column>
        <el-table-column
          prop="type_cn"
          label="企业分类"
          width="auto"
          min-width="13%"
        >
        </el-table-column>
        <el-table-column
          prop="operating"
          label="操作"
          width="auto"
          min-width="7%"
          align="left"
        >
          <template slot-scope="scope">
            <el-button
              class="operateText"
              size="mini"
              type="text"
              @click="toEdit(scope.row)"
              >编辑</el-button
            >
            <el-button
              class="operateText"
              size="mini"
              type="text"
              @click="toDelete(scope.row)"
              >删除</el-button
            >
          </template>
        </el-table-column>
      </el-table>
    </div>
    <el-pagination
      :key="elementui_page_key"
      class="elPagination"
      background
      layout="prev, pager, next"
      :page-size="pageMaxSize"
      :page-count="pageCount"
      :current-page="currentPage"
      @current-change="currentChange"
    ></el-pagination>
  </div>
</template>

<script>
import * as Utils from "@/utils/utils.js";
import * as StrUtils from "@/utils/strUtils.js";
import * as Constant from "@/utils/constant.js";
import * as CApi from "@/api/constant_api.js";
import * as Api from "@/api/api.js";
import { URL_PATH, LIST_PAGE_MAX_SIZE } from "@/config/config";
import leftMeun from "@/components/layout/leftMeun";
import headRight from "@/components/layout/headRight";
import headerLayout from "@/components/layout/headerLayoutWxapp";

export default {
  components: {
    leftMeun,
    headRight,
    headerLayout,
  },
  data() {
    return {
      urlPath: URL_PATH,
      updateTime: "上次更新的时间",
      data_list: [], //数据列表
      elementui_page_key: 0,
      pageCount: 0, // 所有页数
      pageMaxSize: 8,
      currentPage: 1,
    };
  },
  activated() {
    this.getList();
  },
  deactivated() {},
  created() {
    this.meunItem = JSON.parse(localStorage.getItem("meunItem"));
    this.meunTitle = this.meunItem.name;
    this.getList();
  },
  methods: {
    // 获取列表
    getList: function () {
      var that = this;
      this.tableLoading = false;
      this.$api
        .shopList({
          token: localStorage.getItem("token"),
          page: this.currentPage,
          limit: this.pageMaxSize,
        })
        .then(({ data }) => {
          let current_page = Utils.listPage(data, this.currentPage);
          if (current_page) {
            this.currentPage = current_page;
            this.getList();
          }
          this.pageCount = data.Data.pageCount;
          this.data_list = data.Data.model;
          this.data_list.forEach((list) => {
            if (list.type_cn.length > 1) {
              var type_cns = "";
              var a = "";
              for (var i = 0; i < list.type_cn.length; i++) {
                type_cns = list.type_cn[i];
                if (i == 0) {
                  a = type_cns;
                } else {
                  a = a + "\xa0" + "/" + "\xa0" + type_cns;
                }
              }
              list.type_cn = a;
            } else {
              list.type_cn = list.type_cn;
            }
          });
          this.tableLoading = false;
        })
        .catch(({ error }) => {
          this.tableLoading = false;
        });
    },
    currentChange(val) {
      this.elementui_page_key++;
      this.currentPage = val;
      this.getList();
    },
    // 跳转到详情
    toDetails(item) {
      // this.$router.push({
      //   path: "/wxapp/association",
      //   query: {
      //     id: item.id,
      //     title: item.title,
      //   },
      // });
    },
    // 新建
    toAdd() {
      this.$router.push({
        path: "/wxapp/enterprise_add",
      });
    },
    // 编辑
    toEdit(row) {
      console.log(row);
      this.$router.push({
        path: "/wxapp/enterprise_detail",
        query: {
          id: row.shop_log_id,
        },
      });
    },
    // 删除
    toDelete(row) {
      this.$confirm("是否删除此企业？", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
      })
        .then(() => {
          this.$api
            .delShop({
              token: localStorage.getItem("token"),
              id: row.id,
            })
            .then(({ data }) => {
              console.log(data);
              this.getList();
            })
            .catch(({ error }) => {});
        })
        .catch(() => {});
    },
    // headerStyle() {
    //   return "font-family: 'PingFang SC';font-style: normal;font-weight: 400;font-size:14px;line-height: 22px;color: rgba(0, 0, 0, 0.65);";
    // },
  },
};
</script>

<style lang="less" scoped>
.tableInfotext {
  margin-top: 20px;
}
.mainbody {
  background-color: #ffffff;
  border-radius: 5px;
  padding-bottom: 85px;
}
.mainbody .title {
  font-family: "PingFang SC";
  font-style: normal;
  font-weight: 800;
  font-size: 16px;
  line-height: 24px;
  color: #474747;
}
.mainbody .aLine {
  background-color: #e9e9e9;
  height: 1px;
}
.mainbody .tableInfo {
  box-sizing: border-box;
  margin-left: 32px;
  margin-right: 32px;
}
.elPagination {
  margin-top: 30px;
  margin-right: 32px;
}
</style>


// WEBPACK FOOTER //
// src/components/enterprise/enterpriseList.vue